import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { ParentNodeProvider } from '../../providers/ParentNodeProvider';
import { TextContent } from '../TextContent/TextContent';
import './TwoColumnTextImage.scss';

export const TwoColumnTextImage = ({ node, children }) => {
    const heading = node.relationships?.field_text?.field_heading ?? null;
    const img = node.relationships?.field_image;

    if (!img) {
        return (
            <p className="component-error">
                ERROR: This component must have an image.
            </p>
        );
    }

    return (
        <ParentNodeProvider nodeName={heading} nodeType="Two_Column_Text_Image">
            <section
                className={`themed-container c--two-column-text-image ${node.field_theme.toLowerCase()}`}
            >
                <div
                    className={`kite-container ${node.field_lr_align.toLowerCase()}`}
                >
                    <div className="left text">
                        {node.relationships?.field_text && (
                            <TextContent
                                node={node.relationships?.field_text}
                            />
                        )}
                        {children && (
                            <section className="two-column-children">
                                {children}
                            </section>
                        )}
                    </div>
                    <GatsbyImage
                        image={getImage(
                            img.relationships?.field_media_image?.localFile
                        )}
                        alt={img.field_media_image?.alt ?? ``}
                    />
                </div>
            </section>
        </ParentNodeProvider>
    );
};

//
